import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW9008Component } from './kymw9008.component';
import { CheckMfaService } from './api-services/check-mfa.service';

/**
 * 2要素認証画面 モジュール設定クラス
 *
 * @export KYMW9008Module
 * @class KYMW9008Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW9008Component,
  ],
  providers: [
    CheckMfaService,
  ]
})
export class KYMW9008Module {

}
